@use '@scss' as *;

@keyframes ctmSlideUp {
from {
            opacity: 0; transform: translateY(8px);
    }

to {
            opacity: 1; transform: translateY(0);
    }
}

@layer module {
.ctm-overlay {
            position: fixed;
            inset: 0;
            z-index: 400;
            display: flex;
            align-items: center;
            justify-content: center;
    }

.ctm-success {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
    }

.ctm-success-icon {
            display: flex;
            align-items: center;
            justify-content: center;
    }

.ctm-success-actions {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
    }

.ctm-modal {
            max-height: 90vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            animation: ctmSlideUp 0.2s ease-out;
    }

.ctm-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.ctm-close {
            border: none;
            cursor: pointer;
    }

.ctm-body {
            display: flex;
            flex: 1;
            overflow: hidden;
    }

.ctm-left {
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
    }

.ctm-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;
    }

.ctm-messages-header {
            display: flex;
            align-items: center;
    }

.ctm-messages-area {
            flex: 1;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
    }

.ctm-empty-messages {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
    }

.ctm-sent-message {
            align-self: flex-end;
            white-space: pre-wrap;
            word-break: break-word;
    }

.ctm-sent-file {
            display: block;
            opacity: 0.9;
    }

.ctm-compose {
            display: flex;
            flex-direction: column;
    }

.ctm-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
    }

      @media (max-width: 719px) {


                .ctm-body {
                        flex-direction: column;
                        overflow-y: auto;
                    }



                .ctm-right {
                        flex: none;
                        overflow: visible;
                    }

                .ctm-messages-header {
                        flex-wrap: wrap;
                    }


                .ctm-messages-hint {
                        flex-basis: 100%;
                    }

                .ctm-messages-area {
                        flex: none;
                        overflow-y: visible;
                    }

          }
} // layer module










@layer app {
.ctm-overlay {
            padding: $size-20;
    }

.ctm-success {
            max-width: $size-420;
            padding: $size-40 $size-30;
            gap: $size-16;
    }

.ctm-success-icon {
            width: $size-56;
            height: $size-56;
            border-radius: 50%;
    }

.ctm-success-title {
            margin: 0;
    }

.ctm-success-actions {
            gap: $size-10;
            margin-top: $size-8;
    }

.ctm-modal {
            border-radius: $size-10;
            width: 100%;
            max-width: $size-760;
    }

.ctm-header {
            padding: $size-18 $size-20;
    }

.ctm-close {
            padding: 0;
    }

.ctm-body {
            min-height: $size-380;
    }

.ctm-left {
            width: $size-240;
            padding: $size-20;
            gap: $size-16;
    }

.ctm-right.drag-active {
            outline-offset: $size-neg-4;
    }

.ctm-hint {
            margin-top: auto;
    }

.ctm-messages-header {
            gap: $size-6;
            padding: $size-12 $size-16;
    }

.ctm-messages-row-label {
            min-width: $size-130;
    }

.ctm-messages-total-chars-row {
            padding-top: $size-4;
            padding-bottom: $size-12;
    }

.ctm-messages-hint {
            margin-left: auto;
    }

.ctm-messages-area {
            padding: $size-16;
            gap: $size-8;
    }

.ctm-empty-messages {
            height: 100%;
            gap: $size-10;
    }

.ctm-sent-message {
            border-radius: $size-10 $size-2 $size-10 $size-10;
            padding: $size-8 $size-12;
            max-width: 80%;
    }

.ctm-sent-file {
            margin-top: $size-2;
    }

.ctm-compose {
            padding: $size-10 $size-14;
            gap: $size-6;
    }

.ctm-footer {
            gap: $size-10;
            padding: $size-14 $size-20;
    }

      @media (max-width: 719px) {
                .ctm-overlay {
                        padding: $size-16;
                    }
                .ctm-header {
                        padding: $size-14 $size-16;
                    }
                .ctm-body {
                        min-height: 0;
                    }
                .ctm-left {
                        width: auto;
                        padding: $size-16;
                    }
                .ctm-hint {
                        margin-top: 0;
                    }
                .ctm-messages-row-label {
                        min-width: 0;
                    }
                .ctm-messages-hint {
                        margin-left: 0;
                    }
                .ctm-messages-area {
                        min-height: $size-140;
                    }
                .ctm-footer {
                        padding: $size-12 $size-16;
                    }
          }

.ctm-close {
            background: none;
    }

.ctm-overlay {
            background: var(--support-overlay-bg);
    }

.ctm-success-icon {
            background: var(--support-success-bg);
            color: var(--support-success-fg);
            font-size: var(--font-size-xl);
    }

.ctm-success-title {
            font-size: var(--font-size-xl);
            font-weight: 600;
            color: var(--support-title-text);
    }

.ctm-modal {
            background: var(--support-surface);
            box-shadow: var(--shadow-overlay);
    }

.ctm-header {
            border-bottom: 1px solid var(--support-border);
    }

.ctm-title {
            font-size: var(--font-size-lg);
            font-weight: 600;
            color: var(--support-title-text);
    }

.ctm-close {
            font-size: var(--font-size-xl);
            color: var(--support-text-faint);
            line-height: 1;
    }

.ctm-close:hover {
            color: var(--support-text-strong);
    }

.ctm-left {
            border-right: 1px solid var(--support-border);
    }

.ctm-right.drag-active {
            background: var(--support-chip-tint);
            outline: 2px dashed var(--support-drag-outline);
    }

.ctm-hint {
            font-size: var(--font-size-sm);
            color: var(--support-text-faint);
            line-height: 1.5;
    }

.ctm-messages-header {
            font-size: var(--font-size-base);
            font-weight: 500;
            color: var(--support-text-label);
    }

.ctm-messages-count {
            color: var(--support-text-faint);
            font-weight: 400;
    }

.ctm-messages-total-chars-row {
            border-bottom: 1px solid var(--support-border);
    }

.ctm-messages-hint {
            font-size: var(--font-size-sm);
            font-weight: 400;
            color: var(--support-text-faint);
    }

.ctm-empty-messages {
            color: var(--support-text-subtle);
            font-size: var(--font-size-base);
    }

.ctm-sent-message {
            background: var(--support-bubble-bg);
            color: var(--support-surface);
            font-size: var(--font-size-base);
            line-height: 1.5;
    }

.ctm-sent-file {
            font-size: var(--font-size-sm);
    }

.ctm-compose {
            border-top: 1px solid var(--support-border);
            background: var(--support-surface);
    }

.ctm-footer {
            border-top: 1px solid var(--support-border);
    }

      @media (max-width: 719px) {
                .ctm-left {
                        border-right: none;
                        border-bottom: 1px solid var(--support-border);
                    }
          }
} // layer app
